import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';
import { GlobalFile } from 'src/app/models/GlobalFile';

import { AddUndefinedObjectFile, FetchGlobalFiles, GetGlobalFilesObject, LinkFileToObject } from './global-files.actions';
import { GlobalFilesState } from './global-files.state';
import { LinkGlobalFileModalComponent } from './link-global-file-modal/link-global-file-modal.component';
import { LinkFileDTO } from './link-object-to-file-modal/link-object-to-file-modal.component';

@Component({
    selector: 'app-global-files',
    templateUrl: './global-files.component.html',
    styleUrls: ['./global-files.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class GlobalFilesComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    @Select(GlobalFilesState.GlobalFiles) globalFiles$: Observable<GlobalFile[]>;
    @Select(GlobalFilesState.GetGlobalFilesByObjectUuid)
    getGlobalFilesByObject$: Observable<(objectUuid: string) => GlobalFile[]>;
    @Select(GlobalFilesState.UndefinedObjectFiles)
    undefinedObjectFiles$: Observable<GlobalFile[][]>;

    @Input() objectUuid: string;
    @Input() type: string;
    @Input() financialMode: boolean;

    allFiles: GlobalFile[] = [];
    objectFiles: GlobalFile[] = [];

    currentUndefinedObjectKey: number = undefined;

    constructor(private store: Store, private logger: NGXLogger, private modalService: NgbModal) {}

    ngOnInit(): void {
        this.store.dispatch(new FetchGlobalFiles());
        this.refresh();
        this.subscriptions.add(
            this.globalFiles$.subscribe((files) => {
                if (files) {
                    this.allFiles = files;
                }
            }),
        );
        this.subscriptions.add(
            this.getGlobalFilesByObject$.subscribe((globalFilesByObject) => {
                const files = globalFilesByObject(this.objectUuid);
                this.objectFiles = files ? files : [];
            }),
        );

        this.subscriptions.add(
            this.undefinedObjectFiles$.subscribe((undefinedObjectFiles) => {
                if (this.currentUndefinedObjectKey == undefined) {
                    this.currentUndefinedObjectKey = undefinedObjectFiles.length;
                }
                this.objectFiles = undefinedObjectFiles[this.currentUndefinedObjectKey];
            }),
        );
    }

    openAddModal() {
        const modalRef = this.modalService.open(LinkGlobalFileModalComponent, {
            windowClass: 'modal-prompt',
        });
        modalRef.componentInstance.data = this.allFiles.filter((f) => !this.objectFiles.includes(f));
        modalRef.componentInstance.emitObject.subscribe((file) => {
            this.add(file);
        });
    }

    add(file: GlobalFile) {
        if (file === undefined) {
            this.logger.debug('File not found');
        }
        if (this.objectUuid) {
            this.logger.debug('Adding file to object');

            const linkFileDTO: LinkFileDTO = {
                price: file.price,
                objectId: this.objectUuid,
            };

            this.subscriptions.add(
                this.store.dispatch(new LinkFileToObject(file.uuid, [linkFileDTO])).subscribe(() => {
                    this.refresh();
                }),
            );
        } else {
            this.store.dispatch(new AddUndefinedObjectFile(file, this.currentUndefinedObjectKey));
        }
    }

    remove(file: GlobalFile) {
        if (file === undefined) this.logger.debug('File not found');
        if (this.objectUuid) {
            this.logger.debug('Removing file from object');
            this.logger.debug('not implemented yet');
            this.subscriptions
                .add
                /*this.store.dispatch(new RemoveUndefinedObjectFile(file, this.currentUndefinedObjectKey)).subscribe(() => {
          //this.refresh();
        })*/
                ();
        } else {
            //this.store.dispatch(new RemoveUndefinedObjectFile(file, this.currentUndefinedObjectKey));
        }
    }

    refresh() {
        this.subscriptions.add(this.store.dispatch(new GetGlobalFilesObject(this.objectUuid)).subscribe());
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
